// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-module--tag--2tYyU","slideLeft":"tag-module--slideLeft--3G38h","floating":"tag-module--floating--31ZQi"};